import { gqlHandleError } from "@/services/graphqlEndPointCommonSetting/graphqlErrorHandler";
import { getGraphqlClient } from "@/services/graphqlEndPointCommonSetting/gqlClient";
export async function wrapGqlRequest(
  queryOrMutation,
  variables = {},
  operationName = "",
  authRequired = true,
) {

  const excludedOperations = ["generateCustomerToken", "createCustomerV2", "resetPassword", "requestPasswordResetEmail"];

  let passAuthHeader = excludedOperations.includes(operationName);

  const client = getGraphqlClient({ passAuthHeader: !passAuthHeader });

  try {
    const isMutation = /^\s*mutation\b/i.test(queryOrMutation);
    const op = isMutation
      ? client.mutation(queryOrMutation, variables)
      : client.query(queryOrMutation, variables);
    const response = await op.toPromise();
    if (response.error) {
      await gqlHandleError(response.error, variables, client.url, authRequired);
    }
    if (response.data?.[operationName]?.user_errors?.length > 0) {
      await gqlHandleError(
        { userErrors: response.data[operationName].user_errors }, //response.data?.[operationName]?.user_errors,
        variables,
        client.url,
      );
    }
    if (response.data?.[operationName]?.errors?.length > 0) {
      await gqlHandleError(
        { userErrors: response.data[operationName].errors }, //response.data?.[operationName]?.user_errors,
        variables,
        client.url,
      );
    }
    return operationName && response.data
      ? response.data[operationName]
      : response.data;
  } catch (error) {
    await gqlHandleError(error, variables, client.url, authRequired);
  }
}
